import axios from 'axios'

axios.defaults.timeout = 50000;

//axios.defaults.baseURL = 'http://www.bjqxfw.cn:7001/';
axios.defaults.baseURL = 'http://www.bjqxfw.cn:11080/Meteorologicals';

//http request 拦截器
axios.interceptors.request.use(
    config => {
      config.headers = {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        //'Content-Type': 'application/json;charset=UTF-8'
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
)

//http response 拦截器
axios.interceptors.response.use(
    response => {
      return response
    },
    error => {
      return Promise.reject(error);
    }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {params: data})
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}
